/** Keeps platform administrators out of Pro while their portal is unavailable. */

import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "@/contexts/AuthContext";
import { ROUTES } from "@/app/routes";

interface AdminRedirectProps {
  children: React.ReactNode;
}

export const AdminRedirect: React.FC<AdminRedirectProps> = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("AdminRedirect must be used within AuthProvider");
  }

  if (authContext.isAuthenticated && authContext.tokenManagement.isPlatformAdmin()) {
    return <Navigate to={ROUTES.PORTAL_UNAVAILABLE} replace />;
  }

  return <>{children}</>;
};
